<template>
  <v-container fluid class="pa-0" fill-height>
    <div v-if="error" class="form-error">
      <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
    </div>
    <template>
      <v-layout align-center justify-center row fill-heigh>
        <v-flex
          xl4
          lg5
          md10
          sm12
          xs12
          class="ml-5 titulo form-flex"
        >
          <v-flex
            xs12
            class="text-xs-center"
            style="
              position: relative;
              width: 100%;
              height: auto;
              background-size: cover;
              margin-bottom: 6em;
            "
          >
            <img
              class="logo"
              style="width: 20em; height: auto;"
              :src="require('@/assets/logomarca.png')"
              alt="Apetrus logomarca"
            >
            <h1
              style="
                position: absolute;
                top: 83%;
                left: 51%;
                transform: translate(-53%, -15%);
                color: #074d6e;
                font-size: 50pt;
                font-family: Georgia, serif;
                font-weight: 600;
                text-align: center;
              "
              >
                PDV
              </h1>
          </v-flex>
          <v-layout align-space-around justify-space-between column fill-height>
            <template v-if="!user">
              <v-flex
                style="
                  display: flex;
                  justify-content: center;
                  flex-direction: column;
                "
                class="justify-center align-center text-xs-center"
              >
                <v-form class="form" ref="form" v-model="valid" lazy-validation >
                  <v-alert v-model="loginErro" type="error" outline>
                    <h4>Atenção!</h4>
                    {{errorMessage}}
                  </v-alert>

                  <template v-if="!primeiroAcesso">
                    <v-text-field v-model="login.email" box label="E-mail"></v-text-field>
                    <v-text-field v-model="login.password" box label="Senha" type="password"  @keyup.enter="fazerLogin"></v-text-field>
                    <div class="mb-1 mt-2">
                      <a @click="primeiroAcesso = true">Primeiro acesso</a>
                    </div>
                    <div class="cadastro mb-3">
                      <span>
                        Esqueceu sua senha?
                        <a @click="sendResetMail = true">Alterar</a>
                      </span>
                    </div>
                    <v-layout row align-space-around>
                      <v-btn
                        block
                        round
                        dark
                        :loading="loading"
                        :disabled="loading"
                        color="secondary"
                        class="white--text btnLogin"
                        @click="fazerLogin"
                      >
                        Entrar
                      </v-btn>
                    </v-layout>
                  </template>

                  <template v-else>
                    <h2 class="mb-4" style="color: #074d6e; text-align: center">
                      Realizar primeiro acesso
                    </h2>
                    <template v-if="!inserirSenha">
                      <v-text-field
                        v-model="email"
                        class="pb-3"
                        hide-details
                        box
                        label="E-mail"
                      ></v-text-field>
                      <v-text-field
                        v-model="matricula"
                        class="pb-3"
                        hide-details
                        box
                        label="Matrícula"
                      ></v-text-field>
                    </template>

                    <template v-else>
                      <v-text-field
                        :disabled="inserirSenha"
                        v-model="email"
                        class="pb-3"
                        hide-details
                        box
                        label="E-mail"
                      ></v-text-field>

                      <v-text-field
                        hide-details
                        class="pb-1"
                        v-model="senha"
                        box
                        label="Senha"
                        type="password"
                        :rules="[
                          (v) => {
                            if (v) {
                              return (v.length && v.length > 5) || '';
                            } else {
                              return false;
                            }
                          },
                        ]"
                      ></v-text-field>

                      <v-text-field
                        hide-details
                        class="pb-1 mt-3"
                        v-model="Confirmarsenha"
                        box
                        label="Confirma Senha"
                        type="password"
                        :rules="[
                          (v) => {
                            if (senha !== v) {
                              return 'Senhas Diferentes';
                            }
                            return false;
                          },
                        ]"
                      ></v-text-field>
                    </template>
                    <div>
                      <v-layout row align-space-around class="mt-2">
                        <v-btn
                          block
                          round
                          :disabled="loading"
                          @click="primeiroAcesso = false"
                          >Voltar</v-btn
                        >
                        <v-spacer></v-spacer>
                        <v-btn
                          block
                          round
                          :loading="loading"
                          color="secondary"
                          class="white--text btnLogin"
                          @click="function () {
                            if (inserirSenha) {
                              cadastrarEmFirebase()
                            } else {
                              confirmarMatricula()
                            }
                          }"
                          :disabled="
                            inserirSenha && (senha !== Confirmarsenha || !senha)
                          "
                          >Confirmar</v-btn
                        >
                      </v-layout>
                    </div>
                  </template>

                </v-form>
              </v-flex>
            </template>
            <template v-else>
              <v-flex class="text-xs-center">
                <h1>Seguir como:</h1>
                <v-chip color="primary" dark close @input="logout()">
                  <v-avatar>
                    <img v-if="user.image" :src="user.image" alt="trevor" />
                    <v-icon v-else>account_circle</v-icon>
                  </v-avatar>
                  {{ user.email }}
                </v-chip>
              </v-flex>
              <v-flex class="pa-5">
                <v-btn
                  block
                  round
                  v-if="!isUserVerified"
                  color="error"
                  dark
                  @click="resendEmail"
                >Usuário não verificado, reenviar e-mail!</v-btn>
                <v-btn
                  v-else
                  block
                  round
                  :loading="loading"
                  :disabled="loading"
                  color="success"
                  class="white--text btnLogin"
                  @click="$router.push(lastPage ? lastPage : '/home')"
                >Continue</v-btn>
              </v-flex>
            </template>
          </v-layout>
        </v-flex>
      </v-layout>
    </template>

    <!----------------------dialog cadastro-------------------------->
    <v-dialog
      v-model="dialogCad"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card width="100%" height="100%">
        <iframe
          :src="url_cadastro"
          frameborder="0"
          :style="{width: '100%', height: '100%'}"
          ref="frameCad"
        ></iframe>
      </v-card>
    </v-dialog>
    <v-dialog lazy v-model="sendResetMail" width="350">
      <reset-password v-on:fechar="sendResetMail = false" v-on:sucesso="fecharDialogReset()"></reset-password>
    </v-dialog>
    <v-snackbar v-model="snackbar" color="info" :multi-line="true" :timeout="4000" :vertical="true">
      {{snackbar_text}}
      <v-btn flat @click="snackbar = false">Fechar</v-btn>
    </v-snackbar>
    <mensagem-erro></mensagem-erro>
    <mensagem-sucesso></mensagem-sucesso>
  </v-container>
</template>

<script>
import ResetPassword from '@/components/dialogs/SendResetPassword'
import settings from '@/settings'
import MensagemErro from '@/components/dialogs/MensagemErro'
import MensagemSucesso from '@/components/dialogs/MensagemSucesso'

export default {
  components: { ResetPassword, MensagemErro, MensagemSucesso },
  data: () => ({
    sendResetMail: false,
    primeiroAcesso: false,
    email: '',
    matricula: '',
    inserirSenha: false,
    senha: '',
    Confirmarsenha: '',
    dialogRedefinir: false,
    snackbar: false,
    snackbar_text: null,
    url_cadastro: null,
    dialogCad: false,
    loginErro: false,
    errorMessage: '',
    valid: true,
    login: {
      email: '',
      password: '',
      tipo: ''
    },
    emailRules: [v => !!v || 'Insira seu E-mail!'],
    passwordRules: [v => !!v || 'Insira sua senha!']
  }),
  mounted () {
    this.url_cadastro = settings.urlCadastroUsuario
  },
  created () {
    window.addEventListener('message', e => {
      if (e.data === 'closing_cad') {
        this.dialogCad = false
      }
    }, false)
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    isUserVerified () {
      return this.user.emailVerified
    },
    lastPage () {
      return this.$store.getters.lastPage
    }
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    confirmarMatricula () {
      this.$store.dispatch('confirmarMatricula', {
        'email': this.email,
        'matricula': this.matricula
      }).then(() => {
        this.inserirSenha = true
      })
    },
    cadastrarEmFirebase () {
      this.$store.dispatch('signUserUp', {
        'email': this.email,
        'password': this.senha
      }).then(() => {
        this.clear()
      }).catch(() => {
        this.clear()
        this.primeiroAcesso = false
      })
    },
    clear () {
      this.email = ''
      this.senha = ''
      this.Confirmarsenha = ''
      this.matricula = ''
      this.inserirSenha = false
    },
    fecharDialogReset () {
      this.sendResetMail = false
      this.snackbar_text = 'Link enviado com sucesso, verifique seu e-mail'
      this.snackbar = true
    },
    fazerLogin () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('signUserIn', {
          email: this.login.email.trim(),
          password: this.login.password.trim()
        })
      }
    },
    logout () {
      this.primeiroAcesso = false
      this.$store.dispatch('signUserOut')
    },
    resendEmail () {
      this.$store.dispatch('sendVerifyEmail').then(() => {
        this.snackbar_text =
          'Link de verificação enviado, verifique seu e-mail'
        this.snackbar = true
      })
    }
  }
}
</script>
<style>
.banner {
  width: 100%;
}
.logo {
  width: 30%;
}

.form {
  width: 80%;
  z-index: 2;
  position: relative;
}

.m-auto {
  margin: auto;
}

.curva {
  width: 100%;
  position: absolute;
  right: 0;
  bottom: 0;
}

.onda {
  width: 100%;
  position: absolute;
  right: 0;
  bottom: 0;
}

.tablet {
  width: 100%;
  z-index: 2;
}

.imgCurva {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
}

.imgOnda {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
}

.imgTablet {
  width: 100%;
}

.cadastro * {
  font-size: 90%;
}

.logopequeno {
  width: 7%;
}

.form-error {
  z-index: 2;
  position: absolute;
  right: 0;
  top: 0;
  left: 0;
}

.form-flex:first-child,
.form-error:first-child,
.button-over {
  z-index: 2;
}

@media screen and (min-width: 601px) {
  .imgOnda {
    width: 100%;
  }
}
</style>
